import logoConfiancia from "assets/images/icons/dashboard/logo-confiancia.svg";
import { FC } from "react"

interface FunnelCardHeaderProps {
  logoURL?: string
  altLogo?: string
  title?: string
}

export const FunnelCardHeader: FC<FunnelCardHeaderProps> = ({ logoURL, altLogo, title }) => {
  const logo = logoURL || logoConfiancia


  return <div className="flex flex-col p-4 gap-2 items-center justify-center  border-r w-36 2xl:w-[200px]">
    <div className="flex items-center justify-center w-16 h-16">
      <img
        src={logo}
        alt="pic"
        className="max-w-full max-h-full object-contain"
        loading="lazy"
      />
    </div>
    <p className="text-sm text-center">{title}</p>
  </div>
}
